export const colorsChartDefault = {
    goals: {
        medium: { light: "rgba(6, 50, 84, 1)", dark: "rgba(244, 244, 244, 1)" }
    },
    gray: {
        medium: { light: "rgba(206, 215, 222, 1)" }
    },
    black: {
        petroleum: {
            light: "rgba(6, 50, 84, 1)",
            dark: "rgba(81, 107, 158, 1)"
        },
        // Tinta: no escuro inverte. Sem `dark`, `colorByPath` caia no `light` -- preto
        // puro, 1,29:1 sobre o painel.
        medium: {
            light: "rgba(0, 0, 0, 1)",
            dark: "rgba(244, 244, 244, 1)"
        },
        // Transparente e o proposito, nao um descuido: mesmo valor nos dois temas.
        light: { light: "rgba(0, 0, 0, 0)", dark: "rgba(0, 0, 0, 0)" },
        lightness: {
            light: "rgba(0, 0, 0, 0.2)",
            dark: "rgba(255, 255, 255, 0.33)"
        }
    },
    white: {
        light: { light: "rgba(255, 255, 255, 0.33)" },
        medium: { light: "rgba(255, 255, 255, 1)" }
    },
    basic: {
        // As duas pontas escuras da familia sao tinta e invertem: caindo no `light`,
        // davam 1,08:1 e 1,23:1 sobre o painel escuro -- barras pretas.
        darkside: {
            light: "rgba(0, 27, 47, 1)",
            dark: "rgba(244, 244, 244, 1)"
        },
        darker: {
            light: "rgba(6, 50, 84, 1)",
            dark: "rgba(207, 219, 230, 1)"
        },
        dark: { light: "rgba(46, 85, 115, 1)", dark: "rgba(81, 107, 158, 1)" },
        medium: { light: "rgba(92, 126, 153, 1)" },
        light: { light: "rgba(153, 182, 204, 1)" },
        lighter: { light: "rgba(207, 219, 230, 1)" },
        "darker-died": {
            light: "rgba(46, 85, 115, .9)",
            dark: "rgba(207, 219, 230, .9)"
        }
    },
    purple: {
        darker: {
            light: "#382878",
            dark: "#5e4bb0"
        },
        dark: { light: "#503c98", dark: "#6e58c4" },
        medium: {
            light: "#7060b4",
            dark: "#8171c4"
        },
        light: {
            light: "#9888cc",
            dark: "#a99bd9"
        },
        lighter: {
            light: "#bab0e0",
            dark: "#c7bfe6"
        }
    },
    magenta: {
        darker: { light: "#7a3300", dark: "#c05a17" },
        dark: { light: "#a04200", dark: "#d2691e" },
        medium: {
            light: "#bf5205",
            dark: "#de7a32"
        },
        light: {
            light: "#d46c2a",
            dark: "#e5895a"
        },
        lighter: {
            light: "#edb090",
            dark: "#f0bc9e"
        }
    },
    yellow: {
        darker: {
            light: "rgba(230, 126, 0, 1)",
            dark: "rgba(240, 136, 62, 1)"
        },
        dark: { light: "rgba(255, 183, 0, 1)", dark: "rgba(227, 179, 65, 1)" },
        medium: {
            light: "rgba(255, 226, 0, 1)",
            dark: "rgba(230, 205, 23, 1)"
        },
        light: {
            light: "rgba(255, 237, 102, 1)",
            dark: "rgba(230, 216, 115, 1)"
        },
        lighter: {
            light: "rgba(255, 243, 153, 1)",
            dark: "rgba(230, 221, 161, 1)"
        }
    },
    cyan: {
        darker: {
            light: "#004470",
            dark: "#1d6fa8"
        },
        dark: { light: "#005686", dark: "#1487ce" },
        medium: {
            light: "#1a72a8",
            dark: "#3593cc"
        },
        light: {
            light: "#8abedd",
            dark: "#86c2e8"
        },
        lighter: {
            light: "#c0d8ec",
            dark: "#cfe6f7"
        },
        disabled: { light: "rgba(26, 114, 168, 0.33)" }
    },
    violet: {
        darker: { light: "#1a5244", dark: "#2f8b70" },
        dark: { light: "#1e6b58", dark: "#33a085" },
        medium: { light: "#2e8e72", dark: "#3ead8c" },
        light: { light: "#5aae94", dark: "#6bc2a3" },
        lighter: { light: "#90c8b4", dark: "#9ed6bf" },
        "light-weight": {
            light: "rgba(46, 142, 114, .33)",
            dark: "rgba(62, 173, 140, .33)"
        },
        "lighter-weight": { light: "#e5ffed", dark: "#34d3991a" }
    }
};
